import mediaPixels from "@/mixins/mediaPixels";
import Dialog from 'quasar/src/plugins/dialog/Dialog.js';;
import ActionOutcomeAlert from "@/components/UI/ActionOutcomeAlert.vue";

export default {
  mixins: [mediaPixels],
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    enableMobileDisplay() {
      return this.windowWidth <= 769;
    }
  },
  created() {
    window.addEventListener("resize", this.windowResizeHandler);
  },
  unmounted() {
    window.removeEventListener("resize", this.windowResizeHandler);
  },
  methods: {
    windowResizeHandler() {
      this.windowWidth = window.innerWidth;
    },
    backToTop(behavior = "smooth") {
      window.scroll({
        top: 0,
        left: 0,
        behavior: behavior
      });
      let page = document.getElementById("page_container");
      page.scrollIntoView({ behavior: behavior, block: "start" });
    },
    isElementInViewport(el) {
      let rect = el.getBoundingClientRect();

      if (rect.width == 0 && rect.height == 0) return false;

      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    onElementInViewport(el, callback) {
      return () => {
        let visible = this.isElementInViewport(el);
        if (visible) {
          if (typeof callback == "function") {
            callback();
          }
        }
      };
    },
    convertToObjectById(array, idField = "id") {
      return typeof array[0][idField] !== "undefined"
        ? array.reduce((a, b) => ({ ...a, [b[idField]]: b }), {})
        : {};
    },
    urlParams() {
      return new URLSearchParams(window.location.search);
    },
    updateUrlParams(params) {
      window.history.replaceState(history.state, null, params);
    },
    formatPhoneNumber(number) {
      let cleaned = ("" + number).replace(/\D/g, "");
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }
      return number;
    },
    getEstimatedMonthlyVehiclePayment(
      price,
      percentDown = 0.2,
      apr = 0.052,
      term = 72
    ) {
      price = parseInt(price);
      let loanAmount = price - price * percentDown;
      return Math.round(
        (loanAmount * (apr / 12)) / (1 - Math.pow(1 + apr / 12, -term))
      );
    },
    convertCamelToSnake(camelString) {
      return camelString.replace(
        /[A-Z]/g,
        letter => `_${letter.toLowerCase()}`
      );
    },
    convertSnakeToCamel(snakeString) {
      return snakeString.toLowerCase().replace(/([-_][a-z])/g, group =>
        group
          .toUpperCase()
          .replace("-", "")
          .replace("_", "")
      );
    },
    formatNumber(x, abbreviated = false, abbreviatedDecimalPlaces = 0) {
      let formattedNumber = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (abbreviated) {
        let abbreviation = "k";
        if (x >= 1000000) {
          abbreviation = "M";
        } else if (x >= 10000000) {
          abbreviation = "B";
        }

        if (
          formattedNumber.substring(0, formattedNumber.indexOf(",")).length > 0
        ) {
          let integerPart = formattedNumber.substring(
            0,
            formattedNumber.indexOf(",")
          );
          let fractionalPart = "";
          if (abbreviatedDecimalPlaces > 0) {
            let decimalValues = formattedNumber.substring(
              formattedNumber.indexOf(",") + 1,
              formattedNumber.indexOf(",") + 1 + abbreviatedDecimalPlaces
            );

            fractionalPart = "." + decimalValues;
          }
          formattedNumber = integerPart + fractionalPart + abbreviation;
        }
      }
      return formattedNumber;
    },
    getNearestThousandRange(number) {
      const minRange = Math.floor(number / 1000) * 1000;
      const maxRange = Math.ceil(number / 1000) * 1000;

      return {
        min: minRange,
        max: maxRange
      };
    },
    getOrdinalSuffix(i, includeNumberInReturnValue = true) {
      let j = i % 10,
        k = i % 100;
      let suffix = "th";
      if (j === 1 && k !== 11) {
        suffix = "st";
      }
      if (j === 2 && k !== 12) {
        suffix = "nd";
      }
      if (j === 3 && k !== 13) {
        suffix = "rd";
      }
      return includeNumberInReturnValue ? i + suffix : suffix;
    },
    horizontalScrollClickStart(event) {
      this.clickLocation = {
        x: event.clientX,
        y: event.clientY
      };
    },
    horizontalScrollClickEnd(event, clickedCallback) {
      let clickDragThreshold = 10;
      let deltaX = Math.abs(event.clientX - this.clickLocation.x);
      let deltaY = Math.abs(event.clientY - this.clickLocation.y);
      let wasClickOperation =
        deltaX < clickDragThreshold && deltaY < clickDragThreshold;
      if (wasClickOperation) {
        clickedCallback();
      }
    },
    triggerActionOutcomeAlert(message) {
      Dialog.create({
        component: ActionOutcomeAlert,
        componentProps: {
          message
        }
      });
    },
    generateVisitorProfile() {
      let recentlyClickedVehicles = window.localStorage.getItem(
        "jfpc-clicked-vehicles"
      )
        ? JSON.parse(window.localStorage.getItem("jfpc-clicked-vehicles"))
        : [];

      if (recentlyClickedVehicles.length === 0) {
        return {};
      } else {
        recentlyClickedVehicles.sort((a, b) => b.time_clicked - a.time_clicked);

        let profile = {
          year: {},
          make: {},
          model: {},
          price_range: {},
          body_type: {},
          exterior_color: {},
          fuel_type: {},
          mileage_range: {},
          drivetrain: {},
          condition: {},
          features: {}
        };

        recentlyClickedVehicles.forEach(vehicle => {
          Object.keys(profile).forEach(key => {
            if (["price_range", "mileage_range"].includes(key)) {
              let keyTrimmed = key.replace("_range", "");
              let range = this.getNearestThousandRange(vehicle[keyTrimmed]);
              let rangeKey = range.min + "-" + range.max;
              if (!(rangeKey in profile[key])) {
                profile[key][rangeKey] = 0;
              }
              ++profile[key][rangeKey];
            } else if (key === "features") {
              if (key in vehicle) {
                Object.keys(vehicle[key]).forEach(feature => {
                  if (vehicle[key][feature] == 1) {
                    if (!(feature in profile[key])) {
                      profile[key][feature] = 0;
                    }
                    ++profile[key][feature];
                  }
                });
              }
            } else {
              if (!(vehicle[key] in profile[key])) {
                profile[key][vehicle[key]] = 0;
              }
              ++profile[key][vehicle[key]];
            }
          });
        });

        profile.make_model = profile.model;
        delete profile.model;

        return profile;
      }
    },
    getTimeOfDayGreeting() {
      const hour = new Date().getHours();
      let greeting = "";

      if (hour < 5 || hour >= 23) {
        greeting = "Welcome";
      }
      if (hour < 12) {
        greeting = "Good Morning";
      } else if (hour < 17) {
        greeting = "Good Afternoon";
      } else if (hour < 23) {
        greeting = "Good Evening";
      }

      return greeting;
    },
    sortMoney(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return (
        Number(a.replace(/(^\$|,)/g, "")) - Number(b.replace(/(^\$|,)/g, ""))
      );
    },
    sortPercentage(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return (
        parseInt(a.replace("%", "").replaceAll(",", ""), 10) -
        parseInt(b.replace("%", "").replaceAll(",", ""), 10)
      );
    },
    sortInteger(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return (
        parseInt(a.toString().replaceAll(",", ""), 10) -
        parseInt(b.toString().replaceAll(",", ""), 10)
      );
    },
    sortDecimal(a, b) {
      if (a === "-") {
        a = "-999999999";
      }
      if (b === "-") {
        b = "-999999999";
      }
      return Number(a) - Number(b);
    },
    sortDate(a, b) {
      if (!a || a.length === 0 || a === "-") a = "1980-01-01";
      if (!b || b.length === 0 || b === "-") b = "1980-01-01";
      return this.$dayjs(a).unix() - this.$dayjs(b).unix();
    },
    attachContentViewListeners(element, eventData = {}) {
      if (this.isElementInViewport(element)) {
        window.jfpe.track("ContentView", eventData);
      } else {
        let viewedHandler = this.onElementInViewport(element, () => {
          if (window.removeEventListener && viewedHandler) {
            window.removeEventListener(
              "DOMContentLoaded",
              viewedHandler,
              false
            );
            window.removeEventListener("load", viewedHandler, false);
            document.removeEventListener("scroll", viewedHandler, true);
            window.removeEventListener("resize", viewedHandler, false);
          }
          if (resizeObserver) {
            resizeObserver.unobserve(element);
            window.jfpe.track("ContentView", eventData);
          }
        });

        let resizeObserver = new ResizeObserver(viewedHandler);
        resizeObserver.observe(element);

        if (window.addEventListener) {
          window.addEventListener("DOMContentLoaded", viewedHandler, false);
          window.addEventListener("load", viewedHandler, false);
          document.addEventListener("scroll", viewedHandler, true);
          window.addEventListener("resize", viewedHandler, false);
        }
      }
    },
    convertScoreToDealPhrase(score) {
      if (score >= 93) {
        return "Diamond In The Rough";
      } else if (score >= 80) {
        return "Great Deal";
      } else if (score >= 60) {
        return "Good Deal";
      } else if (score >= 40) {
        return "Fair Deal";
      } else {
        return "Poor Deal";
      }
    },
    convertScoreToPhrase(score) {
      if (score >= 93) {
        return "Excellent";
      } else if (score >= 80) {
        return "Great";
      } else if (score >= 60) {
        return "Good";
      } else if (score >= 40) {
        return "Fair";
      } else {
        return "Poor";
      }
    },
    convertScoreToHighLowInvertedPhrase(score) {
      if (score >= 93) {
        return "Extremely Low";
      } else if (score >= 80) {
        return "Very Low";
      } else if (score >= 60) {
        return "Low";
      } else if (score >= 40) {
        return "Normal";
      } else {
        return "High";
      }
    },
    convertScoreToColor(score, excludePlatinum = false) {
      if (score >= 93 && !excludePlatinum) {
        return "#d1eeff";
      } else if (score >= 80) {
        return "#43e46c";
      } else if (score >= 60) {
        return "#28ae60";
      } else if (score >= 40) {
        return "#F2C037";
      } else {
        return "#EF4444";
      }
    },
    convertScorePhraseToScore(phrase) {
      let phraseMap = {
        excellent: 99,
        great: 92,
        good: 79,
        fair: 59,
        poor: 39
      };
      return phraseMap[phrase.toLowerCase()] || 0;
    }
  }
};
